import { graphql } from 'relay-runtime';

export const customThemeProviderQuery = graphql`
    query customThemeProviderQueryCustomStyleQuery {
        marketplaceCustomStyleForSeller {
            customStyle {
                isToolbarHidden
                isSidebarHidden
                isHelpWidgetHidden
                isExternalLinksHidden
                backofficeCustomTheme {
                    app {
                        font
                        primary
                        primary_dark
                        primary_light
                        secondary
                        secondary_alt
                        backgroundColor
                        backgroundColorBase
                        secondary_dark
                        backgroundColor_dark
                        highlighted
                        backgroundToolbar
                        disabledOpacity
                        component {
                            tabs {
                                textColor
                                fontSize
                                backgroundColor
                                padding
                                borderBottomColor
                                hover {
                                    backgroundColor
                                }
                                active {
                                    textColor
                                    borderBottomColor
                                    backgroundColor
                                }
                            }
                            accordion {
                                titleColor
                                lineColor
                                textItemColor
                            }
                            pageTitle {
                                size
                                textColor
                                weight
                            }
                            card {
                                borderRadius
                                title {
                                    color
                                    weight
                                    size
                                }
                                text {
                                    color
                                    weight
                                    size
                                }
                            }
                            link {
                                color
                                decoration
                            }
                            icon {
                                button {
                                    default {
                                        color
                                        width
                                        height
                                    }
                                    hover {
                                        color
                                        width
                                        height
                                    }
                                }
                                info {
                                    default {
                                        color
                                        width
                                        height
                                    }
                                    hover {
                                        color
                                        width
                                        height
                                    }
                                }
                                help {
                                    color
                                    width
                                    height
                                }
                            }
                            message {
                                backgroundColor
                                padding
                                borderRadius
                                fontWeight
                                fontSize
                                warning {
                                    backgroundColor
                                    color
                                }
                                error {
                                    backgroundColor
                                    color
                                }
                            }
                            checkbox {
                                borderRadius
                                width
                                height
                                textWeight
                                textSize
                                unselected {
                                    active {
                                        background
                                        border
                                    }
                                    disabled {
                                        background
                                        border
                                    }
                                }
                                selected {
                                    active {
                                        background
                                        border
                                        inputColor
                                    }
                                    disabled {
                                        background
                                        border
                                        inputColor
                                    }
                                }
                            }
                            switch {
                                borderRadius
                                width
                                height
                                default {
                                    backgroundColor
                                    textWeight
                                    textSize
                                }
                                selected {
                                    backgroundColor
                                    textWeight
                                    textSize
                                }
                            }
                            radio {
                                borderRadius
                                width
                                height
                                textWeight
                                textSize
                                unselected {
                                    active {
                                        background
                                        border
                                    }
                                    disabled {
                                        background
                                        border
                                    }
                                }
                                selected {
                                    active {
                                        background
                                        border
                                        inputColor
                                    }
                                    disabled {
                                        background
                                        border
                                        inputColor
                                    }
                                }
                            }
                            button {
                                borderRadius
                                fontSize
                                fontWeight
                                primary {
                                    border
                                    default {
                                        backgroundColor
                                        textColor
                                    }
                                    hover {
                                        backgroundColor
                                        textColor
                                    }
                                    active {
                                        backgroundColor
                                        textColor
                                    }
                                    disabled {
                                        opacity
                                        backgroundColor
                                        textColor
                                        border
                                    }
                                }
                                basic {
                                    border
                                    default {
                                        backgroundColor
                                        textColor
                                    }
                                    hover {
                                        backgroundColor
                                        textColor
                                    }
                                    active {
                                        backgroundColor
                                        textColor
                                    }
                                    disabled {
                                        opacity
                                        backgroundColor
                                        textColor
                                        border
                                    }
                                }
                                destructive {
                                    border
                                    default {
                                        backgroundColor
                                        textColor
                                    }
                                    hover {
                                        backgroundColor
                                        textColor
                                    }
                                    active {
                                        backgroundColor
                                        textColor
                                    }
                                    disabled {
                                        opacity
                                        backgroundColor
                                        textColor
                                        border
                                    }
                                }
                                disabled {
                                    border
                                    backgroundColor
                                    textColor
                                }
                            }
                            textButton {
                                primary {
                                    default {
                                        color
                                    }
                                    hover {
                                        color
                                    }
                                    active {
                                        color
                                    }
                                }
                                destructive {
                                    default {
                                        color
                                    }
                                    hover {
                                        color
                                    }
                                    active {
                                        color
                                    }
                                }
                            }
                            pageBlocksContainer {
                                pageBlock {
                                    backgroundColor
                                    border
                                    borderRadius
                                    padding
                                    height
                                    pageBlockTitle {
                                        color
                                        gap
                                        fontSize
                                        fontWeight
                                    }
                                    pageBlockDescription {
                                        fontSize
                                    }
                                    pageBlockButton {
                                        padding
                                        fontSize
                                    }
                                    pageBlockLearnMore {
                                        color
                                        fontSize
                                        fontWeight
                                    }
                                }
                            }
                        }
                    }
                    input {
                        textSize
                        color
                    }
                    text {
                        boldWeight
                    }
                    button {
                        color
                        textColor
                    }
                    skeleton {
                        backgroundColor
                        foregroundColor
                    }
                    size {
                        container
                    }
                    font {
                        regular
                        medium
                        semi_bold
                        bold
                        extra_bold
                        black
                    }
                    loadingType
                }
            }
        }
    }
`;
